import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	({ spacing, palette, direction }) => ({
		root: {
			maxWidth: `calc(100% + ${spacing(2)})`,
			flexWrap: 'nowrap',
			overflow: 'auto',
			padding: 2,
			marginTop: spacing(-1.5),
			marginBottom: spacing(-1),
			marginLeft: spacing(-2),
			paddingLeft: spacing(2),
			color: palette.text.secondary,
		},
		addButton: {
			fontFamily: 'Instrument Sans',
			background: 'none !important',
			color: palette.calcContrastColor(palette.scoreapp.primary, palette.background.default),
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'flex-start',
			marginRight: ({ type }) => {
				if (direction !== 'rtl') return 'auto'

				return type === 'checkbox' ? spacing(0.6) : 0
			},
			marginLeft: -3,
			fontSize: spacing(2),
			letterSpacing: 'normal',
			textDecoration: 'none',
			textTransform: 'none',
			lineHeight: 1.5,
			fontStyle: 'normal',
			fontWeight: 400,
		},
		icon: {
			marginRight: direction === 'rtl' ? 0 : null,
			marginLeft: direction === 'rtl' ? spacing(1) : null,
		},
	}),
	{ name: 'Questions-MultipleChoiceCheckboxes-OptionList' },
)

export default useStyles
